import {PureComponent} from 'react';
import template from '../../templates/PageLayout/Popups.rt';
import {connect} from 'react-redux'

function mapStateToProps(state) {
  const {popups, pricingPreset, featureInclusion, newStone, newInstallationGroupItem, newFeature } = state;
  return {
    popups,
    pricingPreset,
    featureInclusion,
    newStone,
    newInstallationGroupItem,
    newFeature,
  }
}

export class Popups extends PureComponent {
  render = template
}

const connector = connect(mapStateToProps);

export default connector(Popups);

